import { useState } from "react";
import { useUpdatePasswordMutation } from "entities/user";
import { getChangePasswordError } from "./getChangePasswordError";
import {
  PasswordErrors,
  PasswordField,
  PasswordValues,
  hasPasswordErrors,
  validatePasswords,
} from "./validatePasswords";

const EMPTY_VALUES: PasswordValues = { current: "", next: "", confirm: "" };

interface UseChangePasswordResult {
  values: PasswordValues;
  setValue: (field: PasswordField, value: string) => void;
  // Ошибки полей показываются только после первой попытки отправки.
  errors: PasswordErrors;
  serverError: string | null;
  submit: () => void;
  isSubmitting: boolean;
  isChanged: boolean;
}

export const useChangePassword = (): UseChangePasswordResult => {
  const [values, setValues] = useState(EMPTY_VALUES);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [updatePassword, { isLoading, isSuccess, error, reset }] =
    useUpdatePasswordMutation();

  const errors = validatePasswords(values);

  const setValue = (field: PasswordField, value: string) => {
    setValues((prev) => ({ ...prev, [field]: value }));
    reset();
  };

  const submit = () => {
    setIsSubmitted(true);
    if (hasPasswordErrors(errors)) return;
    updatePassword({
      current_password: values.current,
      new_password: values.next,
    });
  };

  return {
    values,
    setValue,
    errors: isSubmitted ? errors : {},
    serverError: getChangePasswordError(error),
    submit,
    isSubmitting: isLoading,
    isChanged: isSuccess,
  };
};
